<template>
  <div class="warp-table element-table">
    <el-card class="tableCard" shadow="never">
      <slot name="top"></slot>
      <el-table
        ref="targetTable"
        v-bind="tableAttr.tableProps"
        :data="tableList"
        v-on="$listeners">
        <template v-for="(item, index) in tableAttr.columnItems">
          <el-table-column :key="index" v-bind="item" v-if="item.custom">
            <template v-slot:default="scope">
              <slot :name="item.slotName" v-bind="{item: scope.row, index: scope.$index}"></slot>
            </template>
          </el-table-column>
          <el-table-column :key="index" v-bind="item" v-else-if="item.normalFormat">
            <template slot-scope="scope">
              <span>{{ scope.row[item.prop]  | formatType($enum.getMapItems(item.slotName)) }}</span>
            </template>
          </el-table-column>
          <el-table-column :key="index" v-bind="item" v-else>
          </el-table-column>
        </template>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action" v-if="pageOption.total > 0">
      <el-pagination
        v-on="$listeners"
        v-bind="pageProps"
        :current-page.sync="pageOption.pageNo"
        :page-size.sync="pageOption.pageSize"
        :total="pageOption.total || 0"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import { tableData } from '@/utils/tableProps'

export default {
  name: 'ElementTable',
  props: {
    tableList: {
      type: Array,
      required: true,
      default: () => []
    },
    tableName: {
      required: true,
      type: String
    },
    pageProps: {
      type: Object,
      default: () => ({
        pageSizes: [10, 20, 40, 60, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      })
    },
    pageOption: {
      required: true,
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    tableAttr () {
      return tableData[this.tableName]
    }
  }
}
</script>

<style lang="scss">
.element-table {
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
}
</style>
